import VueTimepicker from './vue-timepicker.vue'
export default VueTimepicker



//////////////////
// WEBPACK FOOTER
// ./~/vue2-timepicker/src/index.js
// module id = 85
// module chunks = 1